import React, { Component } from 'react'

import { Title3 } from '../title/title'
import IconTasting from '../icon/IconTasting'
import IconField from '../icon/IconField'
import IconWaiter from '../icon/IconWaiter'
import IconMenu from '../icon/IconMenu'
import IconPresent from '../icon/IconPresent'
import IconWinery from '../icon/IconWinery'

import styles from './services.module.css'

export default class Services extends Component {
  render() {
    return (
      <section className={styles.section}>
        <Title3 label="Estos son nuestros servicios" />
        <div className={styles.body}>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconPresent size="big" />
            </figure>
            <figcaption className={styles.figcaption}>
              Distribución de vinos
            </figcaption>
          </article>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconWinery size="big" />
            </figure>
            <figcaption className={styles.figcaption}>
              Tienda de vinos
            </figcaption>
          </article>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconTasting size="big" />
            </figure>
            <figcaption className={styles.figcaption}>Catas</figcaption>
          </article>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconWaiter size="big" />
            </figure>
            <figcaption className={styles.figcaption}>
              Sumiller en casa
            </figcaption>
          </article>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconMenu size="big" />
            </figure>
            <figcaption className={styles.figcaption}>
              Asesoría de cartas
            </figcaption>
          </article>
          <article className={styles.article}>
            <figure className={styles.icon}>
              <IconField size="big" />
            </figure>
            <figcaption className={styles.figcaption}>
              Visita a bodegas
            </figcaption>
          </article>
        </div>
      </section>
    )
  }
}
